import { render, staticRenderFns } from "./placeholderProperty.vue?vue&type=template&id=42423f68"
import script from "./placeholderProperty.vue?vue&type=script&lang=js"
export * from "./placeholderProperty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports